.searchContentHeader {
  height: 48px;

  @media all and (width > 1076px) {
    height: 56px;
  }
}

.searchContentHeader > div:first-child {
  flex: 1;
  min-width: 0;
}

.searchContentHeader [class*='reefer_fieldWrapper_labelContainer'] {
  width: 100%;
}

.searchContentHeader input[type='search'] {
  border-color: transparent;
  border-radius: var(--border-radius-lg);
}

@media all and (width <= 1076px) {
  .searchContentHeader button:first-of-type {
    border-color: transparent;
    border-radius: var(--border-radius-lg);
    width: 100%;
    height: 32px;
  }
}

.wizardButton {
  flex-shrink: 0;
  margin-left: auto;
  height: 32px;
  max-width: min-content;

  @media all and (width > 1076px) {
    height: 40px;
  }

  @media all and (width <= 1076px) {
    padding: 8px;
  }
}

.wizardButtonLabel {
  white-space: nowrap;

  @media all and (--reefer-media-tablet-max) {
    display: none;
  }
}
